import classNames from 'classnames';
import { Heading } from 'yoso';
import { BaseCard, BaseCardProps } from '~/components/Card';
import { currencySymbol } from '~/components/Currency/Currency.hooks';
import { T, t } from '~/components/I18n';
import { levelMetaMap, useLevelUpRequirement } from '~/components/Level/Level.hooks';
import { DescriptionList } from '~/components/List/Description/DescriptionList';
import { format, formatCurrency } from '~/components/Util/number';
import styles from './LevelUpGuideCard.module.scss';

export type LevelUpGuideCardProps = BaseCardProps & {
  level: number;
};
export const LevelUpGuideCard = ({ level, className, ...props }: LevelUpGuideCardProps) => {
  const toLevel = level - 1;
  const { data } = useLevelUpRequirement(toLevel);
  const { minNftAmount = 0, purchase, balance } = data || {};
  const { minAmount: purchased = 0 } = purchase || {};
  const { minAmount: minDonAmount } = balance || {};
  const levelMeta = levelMetaMap[level];

  return (
    <BaseCard
      className={classNames(
        styles.root,
        {
          [`citizen-level-${level}`]: level,
        },
        className
      )}
      shadow
      size="large"
      {...props}>
      <BaseCard className={styles.header} color="muted">
        <img
          className={styles.image}
          alt={levelMeta.name}
          src={levelMeta.headImage}
          width={70}
          height={70}
        />
      </BaseCard>
      <div className={styles.body}>
        <Heading level={5} className={styles.heading}>
          {levelMeta.title}
        </Heading>
        <DescriptionList layout="horizontal" className={styles.list}>
          <dt>Citizen</dt>
          <dd>{minNftAmount ? `Lv${toLevel} x ${minNftAmount}` : 'Airdrop'}</dd>
          <dt>DON</dt>
          <dd>{minDonAmount > 0 ? format(minDonAmount) : 'Free'} </dd>
          <dt>
            <T name="citizen_membership_guide_levelup_menu2" />
          </dt>
          <dd>
            {purchased
              ? `${currencySymbol['USD']}${formatCurrency(purchased)}`
              : t('citizen_membership_guide_levelup_notrequired')}
          </dd>
        </DescriptionList>
      </div>
    </BaseCard>
  );
};
